// register icon (e.g., icons/close.js)
/* eslint-disable-next-line import/no-extraneous-dependencies */
const icon = require('vue-svgicon');

icon.register({
  'close-circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `
      <circle cx="12" cy="12" r="12" fill="#E06A6A"></circle>
      <path d="M8 8 L16 16 M16 8 L8 16"
            stroke="#FFFFFF"
            stroke-width="2"
            stroke-linecap="round"/>
    `,
  },
});
